import React from "react";
import SearchComponent from "../../common/search";
import { apsisEncrypt } from "../../helpers/apsisEncryption";
import fetchWrapper from "../../helpers/fetchWrapper";
import {
  apsisDate,
  apsisDateTime,
  apsisMoney,
  apsisQuantity,
} from "../../helpers/helpers";
import { columnShorter } from "../../helpers/sorter";
import { swalConfirm } from "../../helpers/helperService";
import { Button, Input, Modal, Table } from "antd";
import { useEffect, useMemo, useRef, useState, useLayoutEffect } from "react";
import MasterGridArea from "../mastergrid/MasterGrid.style";

export const DropdownGrid = React.forwardRef(
  (
    {
      value,
      name,
      slug,
      onChange,
      getEvent,
      placeholder,
      is_multiple,
      labelKey,
      valueKey,
      displaySelected,
      extra,
      disabled,
      label_name,
      getSelectedKeys,
      visibleGrid = false,
      getSelectedRows,
      disableActionBtn = false,
      selectedItemTitle,
      ...props
    },
    ref
  ) => {
    const isMounted = useRef(false);
    const [primaryKeyField, setPrimaryKeyField] = useState(
      valueKey || "hidden_id"
    );

    // selected options
    const [curInstanceIds, setCurInstanceIds] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedColumn, setSelectedColumn] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState([]);
    const [actionTable, setActionTable] = useState();

    // receive grid data and column
    const [grid_data, setData] = useState([]);
    const [columnData, setColumnData] = useState([]);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagerOptions, setPagerOptions] = useState([]);

    // search configurations
    const [searchConfig, setSearchConfig] = useState({});
    const [inputState, setInputState] = useState("");
    const [searchState, setSearchState] = useState([]);
    const [title, setTitle] = useState("");

    // is visible and loading
    const [visible, setVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const MAX_PAGINATION_VALUE = 999999999;

    useEffect(() => {
      setVisible(visibleGrid);
    }, [visibleGrid]);

    useEffect(async () => {
      if (value && value.constructor === String) {
        await fetchSelectedData(value.split(","));
        setSelectedIds(value.split(","));
      } else if (value && value.constructor === Number) {
        await fetchSelectedData([value]);
        setSelectedIds([String(value)]);
      } else if (value && Array.isArray(value)) {
        await fetchSelectedData(value);
        setSelectedIds(value.map(String));
      } else {
        setSelectedIds([]);
        setSelectedLevel([]);
      }
    }, [visible, value]);

    useLayoutEffect(() => {
      const changePaginationText = setTimeout(() => {
        const findPages = [
          ...document.querySelectorAll(".ant-pagination-options"),
        ];

        for (let findPage of findPages) {
          // Check if findPage exists before adding event listener
          if (findPage) {
            findPage.addEventListener("click", () => {
              // Find the selected content
              const selectedContent = findPage.querySelectorAll(
                ".ant-select-item-option-content"
              );

              // Check if selectedContent exists and then iterate
              if (selectedContent) {
                selectedContent.forEach((element) => {
                  if (
                    element &&
                    element.innerText == `${MAX_PAGINATION_VALUE} / page`
                  ) {
                    element.innerText = "All";
                  }
                });
              }

              // Find the selected item
              const selectedItem = findPage.querySelectorAll(
                ".ant-select-selection-item"
              );

              // Check if selectedItem exists and then iterate
              if (selectedItem) {
                selectedItem.forEach((element) => {
                  if (
                    element &&
                    element.innerText == `${MAX_PAGINATION_VALUE} / page`
                  ) {
                    element.innerText = "All";
                  }
                });
              }
            });
          }
        }
      }, 10);
      return () => {
        clearTimeout(changePaginationText);
      };
    });

    const showModal = async () => {
      setVisible(true);
    };

    const handleClose = () => {
      setVisible(false);
    };

    const handlePagination = async (page, per_page) => {
      setPage(page);
      setPerPage(per_page);
      setCurrentPage(page);
    };

    const sortProductsByIDs = (products, productIDs, primaryKeyField) => {
      try {
        if (products?.length > 0 && productIDs?.length > 0 && primaryKeyField) {
          const updatedProducts = [];
          productIDs.map((id) => {
            const product = products.find(
              (product) => product[primaryKeyField] == id
            );
            product && updatedProducts.push(product);
          });
          if (
            updatedProducts.length > 0 &&
            updatedProducts.length === productIDs.length
          ) {
            return updatedProducts;
          }
          return products;
        }
      } catch (error) {
        return products ?? [];
      }
    };

    const handleSubmit = () => {
      setConfirmLoading(true);
      setTimeout(() => {
        if (onChange) {
          onChange(is_multiple == 1 ? selectedIds : selectedIds[0]);
        }

        if (getEvent) {
          const target = {
            name,
            value: is_multiple == 1 ? selectedIds : selectedIds[0],
            selectedData,
            rules: { required: props?.required },
          };
          getEvent({ target });
        }

        setVisible(false);
        setConfirmLoading(false);
      }, 1000);
    };

    // fetch title
    const fetchTitle = async () => {
      const extra_condition = extra;

      await fetchWrapper
        .post("master-grid/grid-title", {
          slug,
          extra: extra_condition
            ? apsisEncrypt(JSON.stringify({ extra_condition }))
            : apsisEncrypt(JSON.stringify({})),
          search_key: { search_text: inputState },
          search_data: searchState ?? [],
        })
        .then(async (res) => {
          const {
            // total_item,
            columns,
            primary_key_field,
            search_panel,
            master_grid_title,
            action_table,
            page_customize,
          } = res.data;
          // setTotalRows(total_item);
          setActionTable(action_table);
          setSearchConfig(search_panel);
          setTitle(master_grid_title);
          setPrimaryKeyField(primary_key_field);
          setPagerOptions(
            page_customize
              .split(",")
              .map((item) =>
                item === "all" ? MAX_PAGINATION_VALUE : Number(item)
              )
          );

          // set per page
          setPerPage(parseInt(page_customize.split(",")[0]));

          // set column state
          // const tableColumns = columns.map((column) => {
          //   return {
          //     ...column,
          //     title: column.title.toUpperCase(),
          //   };
          // });

          // set column data
          const tableColumns = columns.map((column) => {
            // Add sortable functionality if column is marked as sortable
            if (column.sortable) {
              column.sorter = (a, b) => {
                return columnShorter(a, b, column);
              };
            }

            const render = (value, row, index) => {
              if (column.link) {
                return (
                  <span
                    style={{
                      display: "block",
                      textAlign: column.text_align ?? "left",
                    }}
                  >
                    {value.value}
                  </span>
                );
              }

              if (column.field_type == "date") {
                return (
                  <span
                    style={{
                      display: "block",
                      textAlign: column.text_align ?? "left",
                    }}
                  >
                    {apsisDate(value)}
                  </span>
                );
              }

              if (column.field_type == "datetime") {
                return (
                  <span
                    style={{
                      display: "block",
                      textAlign: column.text_align ?? "left",
                    }}
                  >
                    {apsisDateTime(value)}
                  </span>
                );
              }

              if (column.field_type == "number") {
                return (
                  <span
                    style={{
                      display: "block",
                      textAlign: column.text_align ?? "right",
                    }}
                  >
                    {apsisQuantity(value, row.hidden_uom)}
                  </span>
                );
              }

              if (column.field_type == "money") {
                return (
                  <span
                    style={{
                      display: "block",
                      textAlign: column.text_align ?? "right",
                    }}
                  >
                    {apsisMoney(value, row.hidden_currency)}
                  </span>
                );
              }

              return (
                <span
                  style={{
                    display: "block",
                    textAlign: column.text_align ?? "left",
                  }}
                >
                  {value}
                </span>
              );
            };

            return {
              ...column,
              render,
            };
          });

          setColumnData(tableColumns);
          fetchSelectedTitle(tableColumns);
        })
        .catch((err) => console.log(err));
    };

    // fetch Data
    const fetchData = async (searchData = null) => {
      // const key_field = primaryKeyField.replace("hidden_", "");
      // const selectedArray = selectedIds.map((x) => "'" + x + "'").toString();
      // let extra_condition =
      // selectedArray.length > 0
      // ? { extra_condition: key_field + " NOT IN (" + selectedArray + ")" }
      // : {};

      const extra_condition = extra;

      await fetchWrapper
        .post("master-grid/grid-data", {
          slug,
          extra: extra_condition
            ? apsisEncrypt(JSON.stringify({ extra_condition }))
            : apsisEncrypt(JSON.stringify({})),
          page,
          per_page: perPage,
          search_key: { search_text: inputState },
          search_data: searchState ?? [],
        })
        .then((res) => {
          if (res.data && res.data.items) {
            setTotalRows(res.data?.total_item || 0);
            // set response data
            const responseData = res.data.items;
            const data = responseData.map((item, index) => {
              return {
                key: String(item[primaryKeyField] ?? Object.values(item)[0]),
                ...item,
              };
            });

            // set current instance
            setCurInstanceIds(data.map((item) => item.key));
            // set table data
            setData(data);
          }
        });
    };

    // Fetch Select Titles
    const fetchSelectedTitle = (columns = []) => {
      const gridColumn = columns.length > 0 ? columns : [...columnData];
      const actionColumn = [
        {
          title: "ACTION",
          field_type: "delete_btn",
          link: false,
          dataIndex: "delete_btn",
          key: "delete_btn",
          sortable: false,
          width: "50px",
        },
      ];
      setSelectedColumn([...gridColumn, ...actionColumn]);
    };

    // get selected items
    const fetchSelectedData = async (itemArray = false) => {
      if (
        (!itemArray || itemArray.length <= 0) &&
        (!selectedIds || selectedIds.length <= 0)
      ) {
        setSelectedData([]);
        setSelectedLevel([]);
      } else {
        const key_field = primaryKeyField.replace("hidden_", "");

        let selectedArray = "";
        if (itemArray) {
          selectedArray =
            itemArray && itemArray.map((x) => "'" + x + "'").toString();
        } else {
          selectedArray =
            selectedIds && selectedIds.map((x) => "'" + x + "'").toString();
        }

        const originalExtra = extra ? " AND " + extra : "";

        const extra_condition =
          selectedArray.length > 0
            ? (actionTable && actionTable != ""
              ? actionTable + "." + key_field
              : key_field) +
            " IN (" +
            selectedArray +
            ")" +
            originalExtra
            : "";

        await fetchWrapper
          .post("master-grid/grid-data", {
            slug,
            extra: apsisEncrypt(
              JSON.stringify({ extra_condition: extra_condition.trim() })
            ),
            page: 1,
            per_page: 1000,
          })
          .then((res) => {
            if (res.data && res.data.items) {
              const selectedItems = res.data.items;
              // set selected level
              const items = selectedItems.map((item) => item[labelKey]);
              setSelectedLevel(items);
              setSelectedData(
                sortProductsByIDs(selectedItems, selectedIds, primaryKeyField)
              );
            }
          });
      }
    };

    // delete button component
    const DeleteBtn = (props) => {
      return (
        <button
          key={props.index}
          className={`btn btn-xs del-btn btn-danger`}
          onClick={() => handleDelete(props.primary_key)}
        >
          <i className="fa fa-trash"></i>
        </button>
      );
    };

    // filter data
    const columnsFilter = (columns) => {
      if (!columns) return;
      if (columns.length > 0) {
        columns.forEach((data, index) => {
          if (data[primaryKeyField]) {
            data.key = String(data[primaryKeyField]);
          }
          data.delete_btn = (
            <DeleteBtn index={index} primary_key={data[primaryKeyField]} />
          );
        });
        return columns;
      }
    };

    // filter with memo function
    const filterData = useMemo(() => columnsFilter(selectedData), [
      selectedData,
    ]);

    /*
     * Generate Unique iem
     */
    const onlyUnique = (value, index, self) => {
      return self.indexOf(value) === index;
    };

    /*
     * master grid Selection
     */
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedIds(selectedRowKeys);
        let tempRows = selectedRows.map((row) => {
          delete row.action;
          delete row.delete_btn;
          return row;
        });
        getSelectedKeys && getSelectedKeys(selectedRowKeys);
        getSelectedRows && getSelectedRows(tempRows);

        // //selected item
        const selectItem = selectedRowKeys.map(function (item) {
          return String(item);
        });

        // //update with previous state
        if (is_multiple) {
          const removeIds = curInstanceIds.filter(
            (id) => !selectItem.includes(id)
          );

          const newSelectedIds = selectedIds
            ? selectedIds.filter((id) => !removeIds.includes(id))
            : [];

          setSelectedIds([...newSelectedIds, ...selectItem].filter(onlyUnique));
          // filter selected Items
          const filteredSelectedItems =
            selectedData?.filter(
              (item) => !curInstanceIds?.includes(item.key)
            ) ?? [];

          // generate selected rows
          const newSelectedItems = [...filteredSelectedItems, ...tempRows];
          setSelectedData(
            sortProductsByIDs(
              newSelectedItems,
              [...newSelectedIds, ...selectItem].filter(onlyUnique),
              primaryKeyField
            )
          );
          // update selected Level
          setSelectedLevel(newSelectedItems.map((item) => item[labelKey]));
        } else {
          // update selected ids
          setSelectedIds(selectItem);

          // update selected rows
          setSelectedData(
            sortProductsByIDs(selectedRows, selectItem, primaryKeyField)
          );

          // update selected Level
          setSelectedLevel(selectedRows.map((item) => item[labelKey]));
        }
      },
    };

    // Remove Selection
    const handleDelete = (item) => {
      if (!item) return false;
      swalConfirm("to delete this item").then((rsp) => {
        if (rsp.isConfirmed) {
          if (is_multiple && is_multiple == 1) {
            // const currentItem = [...selectedIds];
            // const currentLevel = [...selectedLevel];
            // const currentSelectedData = selectedData.filter(
            //   (data) => data.key != item
            // );

            // get current item
            // const index = currentItem.indexOf(item.toString());
            // remove items
            // if (index > -1) {
            //   currentItem.splice(index, 1);
            //   currentLevel.splice(index, 1);
            // }

            // update state
            setSelectedLevel((prev) =>
              prev.filter((val) => val?.toString() != item?.toString())
            );
            setSelectedIds((prev) =>
              prev.filter((val) => val?.toString() != item?.toString())
            );
            setSelectedData((prev) =>
              prev.filter(
                (val) => val[primaryKeyField]?.toString() != item?.toString()
              )
            );
          } else {
            setSelectedLevel([]);
            setSelectedIds([]);
            setSelectedData([]);
          }
        }
      });
    };

    const handleInput = (event) => {
      const { value } = event.target;
      setInputState(value);
      handlePagination(1, 10);
    };

    // handle Search
    const handleSearch = (query) => {
      setCurrentPage(1);
      setSearchState(query);
    };

    // call from parent
    React.useImperativeHandle(ref, () => ({
      // getData() { fetchData(1, perPage, is_serial, searchStat); }
    }));

    useEffect(async () => {
      if (visible) {
        await fetchTitle();
        await fetchData();
        await fetchSelectedData();
        isMounted.current = true;
      }
    }, [visible, extra, slug]);

    // when Checked and unchecked
    useEffect(async () => {
      if (isMounted.current) {
        // await fetchTitle();
        await fetchData();
      }
    }, [inputState, searchState, page, perPage]);

    return (
      <div className="d-flex">
        {displaySelected && (
          <div
            className={`dropdown_grid_level ${selectedLevel.length == 0 ? "no-selected" : ""
              }`}
            style={{
              maxHeight: "32px",
              display: "block",
              width: "100%",
              border: "solid 1px",
              borderColor: "#d9d9d9",
              borderRadius: "4px 0 0 4px",
              background: "white",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {selectedLevel.length > 0
              ? selectedLevel.length > 2
                ? selectedLevel.length + " items selected "
                : // selectedLevel.length + ' ' + label_name + 's'
                selectedLevel.toString()
              : "Please select"}
          </div>
        )}
        <Button
          type="primary"
          style={{
            minHeight: "32px",
            background: "#1890FF",
            borderColor: "#1890FF",
            borderRadius: "0 4px 4px 0",
          }}
          size={`${props.btn_size ?? "small"}` || "small"}
          className={`${props.className ?? ""} grid-dropdown-custom-hover`}
          onClick={showModal}
          disabled={disabled || false}
        >
          {props.btn_text || "Select..."}
        </Button>
        <Modal
          open={visible}
          title={props.title ?? title}
          onOk={handleSubmit}
          onCancel={handleClose}
          width={1000}
          zIndex={9999}
          footer={[
            <Button key="back" type="primary" danger onClick={handleClose}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={confirmLoading}
              onClick={handleSubmit}
              disabled={disableActionBtn}
            >
              Submit
            </Button>,
          ]}
          wrapClassName="dropdown-grid"
        >
          <MasterGridArea className="mg">
            {searchConfig && searchConfig?.search_fields && (
              <div className="px-5 dropdown-grip-multiple-search">
                <SearchComponent
                  callFrom={`grid`}
                  searchConfig={searchConfig}
                  setQuery={handleSearch}
                />
              </div>
            )}
            <p className="clearfix"></p>
            <div className="search-filter mr-5">
              <Input
                type="text"
                autoComplete="off"
                name="search_text"
                value={inputState ?? ""}
                onChange={handleInput}
              />
              <span className="icon">
                <i className="fa fa-search" />
              </span>
            </div>

            <Table
              className="mg-table mg-blank"
              rowSelection={{
                type: is_multiple ? "checkbox" : "radio",
                selectedRowKeys: selectedIds,
                ...rowSelection,
              }}
              dataSource={grid_data}
              columns={columnData}
              pagination={{
                onChange: handlePagination,
                pageSize: perPage,
                total: totalRows,
                current: currentPage,
                pageSizeOptions: pagerOptions,
                showSizeChanger: true,
              }}
              scroll={{ x: true }}
            />
            <div className="selected-items">
              <h2 className="px-5">
                {selectedItemTitle || "Selected Employees"}
              </h2>
              <Table
                className="mg-table mg-blank"
                dataSource={filterData}
                columns={selectedColumn}
                pagination={false}
                scroll={{ x: true }}
              />
            </div>
          </MasterGridArea>
        </Modal>
      </div>
    );
  }
);
export default React.memo(DropdownGrid);
